<template>
  <form-model width="1000" title="导出" ref="formModel">
    <Row slot="endcontent" style="margin-top: 20px;" :gutter="16">
      <Col span="5">
      <dl class="taitou" v-for="x in items" :key="x.id">
        <dt>{{ x.name }}</dt>
        <dd :class="{ active: select.x == x.id && select.y == y.id }" @click="clickdd(x, y)"
          v-for="y in x.companyTtList" :key="y.id">
          {{ y.companyName }}
        </dd>
      </dl>
      </Col>
      <Col span="19">
      <h3>{{ item.companyName }}</h3>
      <p style="margin-bottom: 20px">{{ item.companyNamePy }}</p>
      <Row>
        <Col span="8"><ly-form-item label="TEL">{{ item.tel }} </ly-form-item></Col>
        <Col span="8"><ly-form-item label="FAX">{{ item.fax }} </ly-form-item></Col>
        <Col span="8"><ly-form-item label="WEB">{{ item.websiteUrl }}.com
        </ly-form-item></Col>
        <Col span="24"><ly-form-item label="公司地址">{{ item.address }}.com
        </ly-form-item></Col>
      </Row>
      </Col>
    </Row>
    <Button slot="btn" type="primary" @click="daochu">开始导出</Button>
  </form-model>
</template>
<script>
export default {
  data() {
    return {
      openForm: false,
      searchItem: {},
      items: [],
      item: {
        id: 2,
        companyName: "",
        companyNamePy: "",
        address: "",
        tel: "",
        fax: "",
        websiteUrl: "",
        
      },
      forms: [{
        title: "币别",
          key: "currencyForeign",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
      },],
      select: { currencyForeign: "人民币",x: 0, y: 0 },
      //http://127.0.0.1:8080/sellQuotation/exportWord?customerId=1648940548849164289&platformId=8162ea2e-29a5-4da7-b2f6-f48a8cc8e6c5&id=22&tid=5&ttid=0
    };
  },
  methods: {
    reach(v) {
      
      this.getList();
      this.select.startTime = v.startTime;
      this.select.endTime = v.endTime;
      this.select.cid = v.cid;
      setTimeout(() => {
        this.$refs.formModel.reach(this.forms, this.select);
      }, 200);
      //this.select.id = v.id;
    },
    clickdd(x, y) {
      this.select.x = x.id;
      this.select.y = y.id;
      this.item = y;
    },

    daochu(v) {
      var params = [
        {
          name: "cid",
          value: this.select.cid,
        },
        {
          name: "currencyForeign",
          value: this.select.currencyForeign,
        },
        {
          name: "startTime",
          value: this.select.startTime,
        },
        {
          name: "endTime",
          value: this.select.endTime,
        },
        {
          name: "tid",
          value: this.select.x,
        },
        {
          name: "ttid",
          value: this.select.y,
        },
      ];
      this.utils.exportData(
        this.axios.ipPort + "/cloud-tms-server-fms/accountsReceivable/exportExcel",
        params
      );
    },
    exportAll() {
      var params = [
        {
          name: "customerId",
          value: this.searchItem.customerId,
        },
        {
          name: "tid",
          value: this.searchItem.tid,
        },
        {
          name: "ttid",
          value: this.searchItem.ttid,
        },
        {
          name: "startTime",
          value: this.searchItem.startTime,
        },
        {
          name: "endTime",
          value: this.searchItem.endTime,
        },
      ];
      this.utils.exportData(axios.report + "/driving/export/daily", params);
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/exportTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);

        this.items = data;
        if (data.length > 0) {
          this.clickdd(data[0], data[0].companyTtList[0]);
        }
      });
    },
  },
};
</script>
<style>
.taitou dt {
  color: #878787;
  font-size: 18px;
}

.taitou dd {
  padding: 5px;
  cursor: pointer;
}

.taitou dd.active {
  background: #1da2d7;
  color: #fff;
}

.taitou {
  margin-top: 10px;
}

.taitou:first-child {
  margin-top: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/taitou.vue